import React from "react";
import { Box, Typography, Button } from "@mui/material";
import CustomButton from "./CustomButton";
import { Link } from "react-router-dom";

const CallToEnroll = () => {
  return (
    <Box
      sx={{
        backgroundColor: "#065A79",
        py: 6,
        mt:2,
        textAlign: "center",
      }}
    >
      <Typography
        variant="h6"
        sx={{
          mb: 2,
          color: "#FFF",
          fontFamily: "Poppins, sans-serif",
          fontOpticalSizing: "auto",
          fontStyle: "normal",
          letterSpacing: 2,
          fontWeight: "bold",
          p: 1,
        }}
      >
        Join Our New Session
      </Typography>

      <Typography
        variant="h4"
        sx={{
          fontWeight: "bold",
          color: "#FFF",
          mb: 3,

          fontFamily: "Montserrat, sans-serif",
          fontOpticalSizing: "auto",
          fontStyle: "normal",
          letterSpacing: 1,
          textTransform: "uppercase",
        }}
      >
        Call To Enroll Your Child
      </Typography>

      <Typography
        variant="h5"
        sx={{
          fontWeight: "bold",
          color: "#FFF",
          mb: 3,
          mt:4,

          fontFamily: "Montserrat, sans-serif",
          fontOpticalSizing: "auto",
          fontStyle: "normal",
          letterSpacing: 1,

          textTransform: "uppercase",
        }}
      >
        9928263305, 9413645511 
      </Typography>

      <Link to="/contact" style={{ textDecoration: "none" }}>
        <CustomButton ButtonName={" Learn More"} />
      </Link>
    </Box>
  );
};

export default CallToEnroll;